import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/cn"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        common: 'border-transparent bg-muted text-muted-foreground',
        uncommon:
          'bg-accent-pull/20 text-accent-pull border-accent-pull/40',
        rare:
          'bg-accent-primary/20 text-accent-primary border-accent-primary/40',
        holo:
          'bg-accent-secondary/20 text-accent-secondary border-accent-secondary/40',
        ultra_rare:
          'border-transparent bg-gradient-to-r from-accent-primary to-accent-secondary text-primary-foreground',
        pink_glow:
          'border-transparent bg-accent-secondary text-text-0',
        prismatic:
          'border-transparent text-text-0 bg-[linear-gradient(90deg,#ec4899,#a855f7,#06b6d4,#a855f7,#ec4899)] bg-[length:300%_100%] animate-[prismatic-shift_3s_linear_infinite]',
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
